import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestService } from '../../../../services/rest/rest.service';
import { SymbolType } from '../../../../domain/symbol.domain';
import { MarketType } from '../../../../domain/market.domain';
import { FractionalEligibility } from '../domain/order-entry.domain';

@Injectable()
export class FractionalEligibilityRestService {

  constructor(private restService: RestService) {
  }

  getFractionalEligibility(symbol: string, type: SymbolType = SymbolType.STOCK, market: MarketType): Observable<FractionalEligibility> {
    const params = {
      params: {
        symbol,
        type,
        market
      }
    };

    return this.restService.getResource('security.fractionalEligibility').get<FractionalEligibility>(params);
  }

}

